export interface PageIndicatorOptions {
    container: HTMLElement;
    index?: number;
    total?: number;
    onSelect?: (index: number) => void;
    visible?:boolean;
}

export class PageIndicator {
    public readonly onSelect = e5.Signal.create<[number]>();

    private _element: HTMLDivElement;
    private _total: number = 0;
    private _index: number = 0;

    constructor(options: PageIndicatorOptions) {
        options = e5.object.merge({
            index: 0,
            total: 0,
            visible: true
        } as PageIndicatorOptions, options);

        this._element = document.createElement("div");
        this._element.className = "page-indicator";

        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        e5.event.on({
            scope: this._element,
            type: "click",
            selector: `[data-page]`,
            listener: (e) => {
                let pageIndex = parseInt(e.target.getAttribute("data-page"));
                this.onSelect.dispatch(pageIndex);
            }
        });

        this.visible = options.visible;

        this.update(options.index, options.total);

        options.container.appendChild(this._element);
    }

    public get total(): number {
        return this._total;
    }
    public set total(value: number) {
        this.update(this._index, value);
    }

    public get index(): number {
        return this._index;
    }
    public set index(value: number) {
        this.update(value, this._total);
    }

    public update(index: number, total: number): void {
        total = Math.max(total, 0);
        index = Math.max(e5.Calc.clamp(index, 0, total - 1), 0);

        if (total != this._total) {
            this._total = total;
            let html = "";
            if (this._total > 1) {
                for (let i = 0; i < total; ++i) {
                    html += `<div class="page-indicator__item" data-page="${i}"></div>`;
                }
            }
            this._element.innerHTML = html;
        }

        if (this._total > 1) {
            this._index = index;

            this._element.querySelectorAll(".page-indicator__item")
                .forEach((e) => {
                    e.classList.toggle("page-indicator__item--active",
                        e.getAttribute("data-page") == (index + ""));
                });
        }
    }

    public get visible(): boolean {
        return !this._element.classList.contains("e5-hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("e5-hidden", !value);
    }
}